import React, { useMemo, useState } from "react";
import { GenericInfoPopup, Icon, IconName, useDeviceTypes } from "halifax";
import { RouteComponentProps } from "react-router";
import clsx from "clsx";
import {
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
  MODAL_ALERT,
} from "redmond";
import { SEARCH_AGAIN_BUTTON, GENERIC_ERROR_SUBTITLE } from "@capone/common";
import { PATH_HOME } from "../../../../utils/paths";
import { ShopDetailsErrorModalConnectorProps } from "./container";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { parseShopDetailsQueryString } from "../../utils/queryStringHelpers";
import * as textConstants from "./textConstants";

export interface IShopDetailsErrorModalProps
  extends ShopDetailsErrorModalConnectorProps,
    RouteComponentProps {}

export const ShopDetailsErrorModal = (props: IShopDetailsErrorModalProps) => {
  const { hasFailed, history, lodging } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { matchesMobile } = useDeviceTypes();

  const queryString = useMemo(
    () => parseShopDetailsQueryString(history.location.search),
    [history.location.search]
  );

  const modalEventProperties = {
    type: "premium_hotels_dateless_search_error",
    primary_button: SEARCH_AGAIN_BUTTON,
    screen: ModalScreens.PREMIUM_HOTELS_DATELESS_SEARCH,
    category: ModalCategoryType.TROUBLE,
    modal_subtitle: GENERIC_ERROR_SUBTITLE,
    modal_title: textConstants.SHOP_DETAILS_ERROR_TITLE,
    lodging_id: lodging?.id ?? queryString.lodgingId,
    lodging_name: lodging?.name,
    source: queryString.source,
  };

  React.useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const buttons = [
    {
      buttonText: SEARCH_AGAIN_BUTTON,
      buttonWrapperClassName: clsx(
        "shop-details-error-modal-button",
        "primary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.PRIMARY,
          },
        });
        history.push(PATH_HOME);
      },
    },
  ];

  return (
    <GenericInfoPopup
      className="hotel-shop-details-error-modal-root"
      open={isOpen}
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      title={textConstants.SHOP_DETAILS_ERROR_TITLE}
      subtitle={GENERIC_ERROR_SUBTITLE}
      buttons={buttons}
      isMobile={matchesMobile}
    />
  );
};
